import React from "react";
import { FiCheckCircle } from "react-icons/fi";

const SuccessScreen = ({ isUpdate }) => (
  <div className="activation-page__card">
    <FiCheckCircle className="activation-page__icon activation-page__icon--success" />
    <h1 className="activation-page__title">
      {isUpdate ? "Details Updated" : "Details Received!"}
    </h1>
    <p className="activation-page__subtitle">
      {isUpdate
        ? "Your updated details have been received. Our team will review and apply the changes."
        : "Your eSIM activation details have been submitted successfully. You'll receive a confirmation email shortly."}
    </p>
  </div>
);

export default SuccessScreen;
